export const translations = {
  en: {
    nav: {
      events: "Events",
      gallery: "Gallery",
      merch: "Ambassadors",
      contact: "Contact",
      about: "About Us",
    },
    hero: {
      upcoming: "Upcoming",
      events: "Events",
      tagline: "From Seoul to your city.",
      cta: "See all events",
      buyTickets: "Buy Tickets",
      scroll: "Scroll",
      centerLine: "Europe's K-POP nights experience",
    },
    months: [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December",
    ],
    stats: {
      parties: "parties",
      attendees: "attendees",
    },
    upcomingFor: "Upcoming events for",
    upcomingTitle: "Upcoming events",
    sections: {
      gallery: {
        eyebrow: "Aftermovie",
        title: "Inside the Vibe",
        subtitle: "Sweaty lights. Loud bass. Real K-pop fans.",
        cta: "Open gallery",
      },
      about: {
        eyebrow: "About",
        title: "SeoulVibes",
        body: "We bring the biggest K-pop party experience to Czech Republic and Slovakia. Thousands of guests. Sold-out nights. Real Seoul club energy — dropped right into your city.",
        line1: "Dance. Sing. Scream. Repeat.",
        cta: "More about us",
      },
      cities: {
        eyebrow: "Where",
        title: "Cities We Take Over",
      },
      proof: {
        eyebrow: "Proof",
        title: "The Numbers Don't Lie",
        items: [
          { value: "120+", label: "Sold-out nights" },
          { value: "85k", label: "Guests danced with us" },
          { value: "#1", label: "K-pop party in CZ / SK" },
          { value: "3", label: "Capital cities" },
        ],
      },
      contact: {
        eyebrow: "Contact",
        title: "Bookings & Collaborations",
        body: "Press, partnerships, DJ bookings, brand collabs — drop us a line.",
        cta: "Send message",
      },
    },
    footer: {
      tagline: "The biggest K-pop party experience in CZ / SK.",
      rights: "All rights reserved",
      followUs: "Follow",
    },
    eventCard: {
      tickets: "Get Tickets",
      soldOut: "Sold Out",
    },
    pages: {
      events: {
        title: "All Events",
        subtitle: "Your next night out starts here.",
        empty: "No upcoming events. Stay tuned.",
        past: "Past Nights",
      },
      gallery: {
        title: "Gallery",
        subtitle: "Look inside the loudest K-pop nights in CZ / SK.",
      },
      merch: {
        title: "Ambassadors",
        subtitle: "Faces of the SeoulVibes community.",
        buy: "Apply",
        applyTitle: "Become an Ambassador",
        applyBody: "Free entry. Free merch. First access to every drop. Help us bring K-pop nights to your campus.",
        applyCta: "Apply now",
        currentTitle: "Current Crew",
      },
      contact: {
        title: "Get in touch",
        subtitle: "Bookings, press, collabs.",
        name: "Your name",
        email: "Your email",
        subject: "Subject",
        message: "Message",
        send: "Send message",
        success: "Message sent. We'll be in touch.",
        error: "Something went wrong. Try again.",
      },
      about: {
        title: "About SeoulVibes",
        subtitle: "From Seoul to your city.",
        intro: "SeoulVibes is the largest K-pop party brand in Czech Republic and Slovakia. We started as one sweaty night in Prague — today, we sell out clubs across three capitals.",
        what: "What we do",
        whatBody: "We curate authentic K-pop nights — BTS, BLACKPINK, NewJeans, ATEEZ, Stray Kids, IVE, aespa, LE SSERAFIM and the deep cuts you actually want. Add laser lights, photo zones, freebies and a crowd that screams every word — that's a SeoulVibes night.",
        team: "The crew",
        teamBody: "Resident DJs, K-pop choreographers, photographers and a community that grew this brand from zero to #1.",
      },
    },
  },
  cz: {
    nav: {
      events: "Akce",
      gallery: "Galerie",
      merch: "Ambasadoři",
      contact: "Kontakt",
      about: "O nás",
    },
    hero: {
      upcoming: "Nadcházející",
      events: "Akce",
      tagline: "Ze Soulu rovnou k tobě.",
      cta: "Všechny akce",
      buyTickets: "Koupit vstupenky",
      scroll: "Scrolluj",
      centerLine: "Europe's K-POP nights experience",
    },
    months: [
      "leden", "únor", "březen", "duben", "květen", "červen",
      "červenec", "srpen", "září", "říjen", "listopad", "prosinec",
    ],
    stats: {
      parties: "akcí",
      attendees: "hostů",
    },
    upcomingFor: "Nadcházející akce na",
    upcomingTitle: "Nadcházející akce",
    sections: {
      gallery: {
        eyebrow: "Aftermovie",
        title: "Uvnitř Vibe",
        subtitle: "Zpocená světla. Hluboký bass. Skuteční K-pop fanoušci.",
        cta: "Otevřít galerii",
      },
      about: {
        eyebrow: "O nás",
        title: "SeoulVibes",
        body: "Přinášíme největší K-pop párty zážitek do Česka a na Slovensko. Tisíce hostů. Vyprodané noci. Skutečná energie soulských klubů — rovnou ve tvém městě.",
        line1: "Tancuj. Zpívej. Křič. Opakuj.",
        cta: "Více o nás",
      },
      cities: {
        eyebrow: "Kde",
        title: "Města, která ovládáme",
      },
      proof: {
        eyebrow: "Důkaz",
        title: "Čísla nelžou",
        items: [
          { value: "120+", label: "Vyprodaných nocí" },
          { value: "85k", label: "Hostů s námi tančilo" },
          { value: "#1", label: "K-pop párty v CZ / SK" },
          { value: "3", label: "Hlavní města" },
        ],
      },
      contact: {
        eyebrow: "Kontakt",
        title: "Spolupráce & bookingy",
        body: "Press, partnerství, DJ bookingy, brand collaby — napiš nám.",
        cta: "Odeslat zprávu",
      },
    },
    footer: {
      tagline: "Největší K-pop párty zážitek v CZ / SK.",
      rights: "Všechna práva vyhrazena",
      followUs: "Sleduj",
    },
    eventCard: {
      tickets: "Vstupenky",
      soldOut: "Vyprodáno",
    },
    pages: {
      events: {
        title: "Všechny akce",
        subtitle: "Tvoje další noc začíná tady.",
        empty: "Žádné nadcházející akce. Sleduj nás.",
        past: "Minulé noci",
      },
      gallery: {
        title: "Galerie",
        subtitle: "Podívej se dovnitř nejhlasitějších K-pop nocí v CZ / SK.",
      },
      merch: {
        title: "Ambasadoři",
        subtitle: "Tváře komunity SeoulVibes.",
        buy: "Přihlásit se",
        applyTitle: "Staň se ambasadorem",
        applyBody: "Vstup zdarma. Merch zdarma. První přístup ke každému dropu. Pomoz nám přivést K-pop noci na tvou školu.",
        applyCta: "Přihlásit se",
        currentTitle: "Aktuální crew",
      },
      contact: {
        title: "Napiš nám",
        subtitle: "Bookingy, press, collaby.",
        name: "Tvé jméno",
        email: "Tvůj email",
        subject: "Předmět",
        message: "Zpráva",
        send: "Odeslat",
        success: "Zpráva odeslaná. Ozveme se.",
        error: "Něco se pokazilo. Zkus znovu.",
      },
      about: {
        title: "O SeoulVibes",
        subtitle: "Ze Soulu rovnou k tobě.",
        intro: "SeoulVibes je největší K-pop párty značka v Česku a na Slovensku. Začali jsme jednou zpocenou nocí v Praze — dnes vyprodáváme kluby ve třech hlavních městech.",
        what: "Co děláme",
        whatBody: "Pořádáme autentické K-pop noci — BTS, BLACKPINK, NewJeans, ATEEZ, Stray Kids, IVE, aespa, LE SSERAFIM a deep cuts, které si fakt chceš poslechnout. Lasery, photo zóny, freebies a dav, který křičí každé slovo — to je SeoulVibes.",
        team: "Tým",
        teamBody: "Resident DJs, K-pop choreografové, fotografové a komunita, která vytáhla tuhle značku z nuly na #1.",
      },
    },
  },
};
